var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisaDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "20px",
    viewBox: "0 0 34 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Visa-dark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Residential",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "11.Doody.Marketing.Free-Quotes.Additional-Details.03",
    transform: "translate(-965.000000, -263.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(930.000000, 160.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(35.000000, 74.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Visa-dark",
    transform: "translate(0.000000, 29.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#26337A",
    x: 0,
    y: 0,
    width: 33.3333333,
    height: 20,
    rx: 1
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-3",
    fill: "#FFFFFE",
    points: "13.8299969 13.1822535 14.8549094 6.82422535 16.4931951 6.82422535 15.4683763 13.1822535 13.8299969 13.1822535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.410957,6.98028169 C21.0870292,6.85267606 20.5775714,6.71352113 19.9429278,6.71352113 C18.3231951,6.71352113 17.1830292,7.57633803 17.1735653,8.81183099 C17.1632581,9.7257277 17.9871797,10.2353991 18.6083303,10.5391549 C19.246722,10.8505164 19.4612058,11.0497653 19.4586759,11.328169 C19.4542719,11.7539906 18.9491244,11.949108 18.4780845,11.949108 C17.8221705,11.949108 17.4736928,11.8530516 16.9349063,11.6156808 L16.7241705,11.5144601 L16.4950691,12.9376526 C16.8770922,13.1147418 17.5852919,13.2684507 18.3202903,13.2765258 C20.0416897,13.2765258 21.1602104,12.4241315 21.1733287,11.1047887 C21.179232,10.3800939 20.7426743,9.83079812 19.7972212,9.377277 C19.224702,9.08244131 18.8733195,8.88713615 18.8773487,8.58873239 C18.8777235,8.32450704 19.1741966,8.04159624 19.8158679,8.04159624 C20.3517496,8.03295775 20.7396759,8.15671362 21.0419585,8.28591549 L21.1890707,8.35859155 L21.410957,6.98028169",
    id: "Fill-4",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5924332,10.9280751 C23.7282074,10.5626291 24.2450676,9.15089202 24.2450676,9.15089202 C24.23551,9.16769953 24.3800922,8.78262911 24.462831,8.54431925 L24.5733994,9.09267606 C24.5733994,9.09267606 24.8877696,10.6102347 24.9525177,10.9280751 L23.5924332,10.9280751 L23.5924332,10.9280751 Z M25.6135853,6.83070423 L24.3474839,6.83070423 C23.9547788,6.83070423 23.6608356,6.94319249 23.4887988,7.35774648 L21.0558264,13.184507 L22.7765699,13.184507 C22.7765699,13.184507 23.0573011,12.4006573 23.1210184,12.2286385 C23.3087035,12.2286385 24.980722,12.2319249 25.219381,12.2319249 C25.2684808,12.4538028 25.4188725,13.184507 25.4188725,13.184507 L26.9394685,13.184507 L25.6135853,6.83070423 L25.6135853,6.83070423 Z",
    id: "Fill-5",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.455576,6.82957746 L10.8520538,11.1642254 L10.680298,10.2830986 C10.3814823,9.26788732 9.45130261,8.16751174 8.41083564,7.61615023 L9.8778341,13.1767136 L11.6116959,13.1756808 L14.1916866,6.82957746 L12.455576,6.82957746",
    id: "Fill-6",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.36350384,6.82525822 L6.72157604,6.82525822 L6.69983717,6.95699531 C8.75556528,7.48366197 10.1157435,8.75492958 10.680298,10.2830986 L10.1061859,7.36169014 C10.0071429,6.95877934 9.71929032,6.83934272 9.36350384,6.82525822",
    id: "Fill-7",
    fill: "#EC982D"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaDark);
export default __webpack_public_path__ + "static/media/visa_dark.f93218e460690ec3c84e3e8129cb04dc.svg";
export { ForwardRef as ReactComponent };